import CargosService from "@/services/cxc/CargosService";
import TipoCargoService from "@/services/cxp/TipoCargoService";
import CargoSerieService from "@/services/cxc/CargoSerieService";

const fetch = (context, params) => {
  return CargosService.fetch(params)
    .then(res => {
      context.commit('CARGOS', res.data);
    });
};

const setFilter = (context, params) => {
  context.commit('FILTERS', res.data);
  return CargosService.fetch(params)
    .then(res => {
    });
};

const tipocargo = (context, params) => {
  return TipoCargoService.fetch(params)
    .then(res => {
      context.commit('TIPOCARGO', res.data);
    });
};

const cargos = (context, params) => {
  return CargoSerieService.fetch(params)
    .then(res => {
      context.commit('CARGOS', res.data);
    });
};


export default {
  fetch,
  tipocargo,
  cargos,
};